import React from "react";
import SolutionList from "../../components/SolutionList";
const SolutionTotalList = () => {
  return (
    <div>
      <SolutionList type="totalSolution" />
    </div>
  );
};

export default SolutionTotalList;
